import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-the-checkout-from-shopify',
  templateUrl: './the-checkout-from-shopify.component.html',
  styleUrls: ['./the-checkout-from-shopify.component.scss']
})
export class TheCheckoutFromShopifyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
